export default {
	//泰语
	thai: {
		title: 'Douluo Dalu : สัประยุทธ์วิญญาจารย์ ลิขสิทธิ์แท้ ภาพจำลองสมจริงด้วยนวัตกรรมใหม่ รังสรรค์โต้วหลัวต้าลู่ 3D!',
		shareTitle: 'Douluo Dalu : สัประยุทธ์วิญญาจารย์',
		shareMessage: 'การปะทะกันของพรหมยุทธ์ตัวจริง ลิขสิทธิ์แท้ "Douluo Dalu : สัประยุทธ์วิญญาจารย์" เปิดให้ Pre-Register แล้ว วันนี้!',
		languageSelected: 'ไทย',
		languagezh: '中文',
		languagethai: 'ไทย',
		languagevi: 'Tiếng Việt',
		area: 'ประเทศ',
		phone: 'เบอร์มือถือ',
		email: 'อีเมล',
		areaSelected:'ไทย',
		thaiArea: 'ไทย',
		viArea: 'เวียดนาม',
		qitaArea: 'อื่นๆ',
		phoneCode: 'เบอร์มือถือ',
		pleasePhone: 'โปรดป้อนเบอร์มือถือ',
		pleaseEmail: 'โปรดป้อนอีเมล',
		serviceItem: 'เงื่อนไขการใช้บริการ',
		privacyItem: 'นโยบายความเป็นส่วนตัว',
		toPhoneorEmail: 'รางวัล Pre-Register สามารถรับได้ด้วยการผูกมัดเบอร์มือถือ/อีเมล์ในหน้ากิจกรรมภายในเกมส์หลังเกมส์ออนไลน์',
		bagtip: 'รางวัล Pre-Register สามารถรับได้ด้วยการผูกมัดเบอร์มือถือ/อีเมล์ในหน้ากิจกรรมภายในเกมส์หลังเกมส์ออนไลน์',
		phoneError:'เบอร์มือถือไม่ถูกต้อง โปรดป้อนใหม่',
		emailError: 'อีเมลไม่ถูกต้อง โปรดป้อนใหม่',
		timeEnd: 'กิจกรรมสิ้นสุดแล้ว',
		popupTip1: 'Pre-Register แล้ว ร่วมกิจกรรมปลุกพลังวิญญาณยุทธ์ จะได้รับรางวัลมากกว่า!',
		popupTip2: 'แชร์สำเร็จ! วันนี้ท่านได้รับสิทธิ์ปลุกพลังแล้ว พรุ่งนี้ยังสามารถมาอีกได้~',
		popupTip3: 'โปรดยินยอมข้อตกลงผู้ใช้งานและนโนบายความเป็นส่วนตัว',
		popupTip4: 'สิทธิ์ปลุกพลังไม่เพียงพอ หลังทำเควสสำเร็จจะได้รับสิทธิ์ปลุกพลัง',
		popupTip5: 'โปรดลองใหม่ภายหลัง',
	},
	//越南语
	vi: {
		title: 'Đấu La Đại Lục 3D: Hồn Sư Quyết Đấu--Ủy quyền IP kép, chất lượng hình ảnh sắt nét, engine thế hệ mới tạo nên Đấu La Đại Lục 3D!',
		shareTitle: 'Đấu La Đại Lục : Hồn Sư Đối Quyết',
		shareMessage: 'Chân Đấu La, Đối Quyết Thật! Đấu La Đại Lục: Hồn Sư Đối Quyết đang đặt trước!',
		languageSelected: 'Tiếng Việt',
		languagezh: 'Tiếng Trung',
		languagethai: 'Tiếng Thái',
		languagevi: 'Tiếng Việt',
		area: 'Khu Vực',
		phone: 'Số ĐT',
		email: 'Email',
		areaSelected:'Việt Nam',
		thaiArea: 'Thái',
		viArea: 'Việt Nam',
		qitaArea: 'Khác',
		phoneCode: 'Mã Khu Vực',
		pleasePhone: 'Hãy nhập số điện thoại',
		pleaseEmail: 'Hãy nhập địa chỉ Email',
		serviceItem: 'Điều Khoản Dịch Vụ',
		privacyItem: 'Chính Sách Bảo Mật',
		toPhoneorEmail: 'Sau khi chính thức phát hành, quà đăng ký trước sẽ được nhận khi liên kết số điện thoại/email',
		bagtip: 'Sau khi chính thức phát hành, quà đăng ký trước sẽ được nhận khi liên kết số điện thoại/email',
		phoneError:'Sai số điện thoạ, xin nhập lại',
		emailError: 'Email error',
		timeEnd: 'Sự kiện đã kết thúc',
		popupTip1: 'Đã hoàn thành đăng ký, hãy tham gia SK Thức Tỉnh Võ Hồn để nhận thêm quà!',
		popupTip2: 'Đã chia sẻ! Nhận được cơ hội thức tỉnh hôm nay, mai lại đến thôi!',
		popupTip3: 'Vui lòng đọc và đồng ý với Điều Khoản Dịch Vụ và Chính Sách Bảo Mật',
		popupTip4: 'Số lần thức tỉnh không đủ, hoàn thành nhiệm vụ sẽ nhận được số lần.',
		popupTip5: 'Vui lòng thử lại sau',
	},
	//中文
	zh: {
		title: '斗罗大陆3D：魂师对决——双IP授权，动画品质，全新次世代引擎打造3D斗罗大陆！',
		shareTitle: '斗罗大陆3D：魂师对决——双IP授权，动画品质，全新次世代引擎打造3D斗罗大陆！',
		shareMessage: '真斗罗真对决，双IP官方授权，《斗罗大陆3D:魂师对决》事前火热预约进行中！',
		languageSelected: '中文',
		languagezh: '中文',
		languagethai: '泰语',
		languagevi: '越南语',
		area: '地区',
		phone: '手机号',
		email: '邮箱',
		areaSelected:'其他',
		thaiArea: '泰国',
		viArea: '越南',
		qitaArea: '其他',
		phoneCode: '区号',
		pleasePhone: '请输入手机号',
		pleaseEmail: '请输入邮箱',
		serviceItem: '服务条款',
		privacyItem: '隐私协议',
		toPhoneorEmail: '预约奖励将于游戏正式上线后在游戏内活动页面处绑定手机号/邮箱进行领取',
		bagtip: '预约奖励将于游戏正式上线后在游戏内活动页面处绑定手机号/邮箱进行领取。',
		phoneError:'手机号错误，请重新输入',
		emailError: '邮箱格式错误，请重新输入',
		timeEnd: '活动已结束',
		popupTip1: '已完成预约，参与武魂觉醒活动可以获得更多奖励！',
		popupTip2: '分享成功！今日的觉醒机会已获得，欢迎明天再来～',
		popupTip3: '请先勾选用户条款和隐私协议',
		popupTip4: '觉醒次数不足，完成任务可以获得觉醒次数。',
		popupTip5: '请稍后再试~',
	}
}
